var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"white","padding":"2em 2em 2em 2em"},attrs:{"id":"threejs-container-container"}},[_c('div',{style:({width: '100%', height: _vm.vh, border: ''}),attrs:{"id":"threejs-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }